function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class LiveCustomerPortalModel {
    constructor(lcp){
        _define_property(this, "contextValues", void 0);
        _define_property(this, "portal", void 0);
        _define_property(this, "projectId", void 0);
        _define_property(this, "id", void 0);
        _define_property(this, "currentPage", void 0);
        this.contextValues = lcp.contextValues;
        this.portal = lcp.portal;
        this.id = lcp.id;
        this.projectId = lcp.projectId;
        this.currentPage = lcp.currentPage;
    }
}
